/* istanbul ignore file */

import { css } from 'styled-components';
export var shadowUp = /*#__PURE__*/css(["box-shadow:0 -6px 8px -4px rgba(0,0,0,0.2);"]);
export var shadowDown = /*#__PURE__*/css(["box-shadow:0 6px 8px -4px rgba(0,0,0,0.2);"]);
export var shadowRight = /*#__PURE__*/css(["box-shadow:6px 0px 8px -4px rgba(0,0,0,0.2);"]);